import { datetime } from '../config'
import parseISO from 'date-fns/parseISO'
import fromUnixTime from 'date-fns/fromUnixTime'
import format from 'date-fns/format'

export const fromTimestamp = (timestamp, FORMAT = datetime.FORMAT_DATETIME) => {
  if (timestamp) {
    return format(fromUnixTime(timestamp), FORMAT)
  }
}

export const fromDate = (date, FORMAT = datetime.FORMAT_DATE) => {
  if (date) {
    if (typeof date === 'string') return format(parseISO(date), FORMAT)

    return format(date, FORMAT)
  }
}

export default {
  computed: {
    $FORMAT_DATETIME() {
      return {
        DATE: datetime.FORMAT_DATE,
        TIME: datetime.FORMAT_TIME,
        DATETIME: datetime.FORMAT_DATETIME,
      }
    },
  },
}
